module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/price_matching-ffeeffc8c123a9fad37d42ecf0ccbf67.svg";